import { render, staticRenderFns } from "./KidsPrivacy_202411.vue?vue&type=template&id=16213662&scoped=true"
import script from "./KidsPrivacy_202411.vue?vue&type=script&lang=js"
export * from "./KidsPrivacy_202411.vue?vue&type=script&lang=js"
import style0 from "./KidsPrivacy_202411.vue?vue&type=style&index=0&id=16213662&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16213662",
  null
  
)

export default component.exports